// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1KB-M","clinicsSelect":"TableHeading_clinicsSelect__3YMME"};